/**
 * @generated SignedSource<<1ad36a2313b9e91700b58b8d9951af90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CarouselItemTile_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductTile_user" | "useFavoritesItem_user">;
  readonly " $fragmentType": "CarouselItemTile_user";
};
export type CarouselItemTile_user$key = {
  readonly " $data"?: CarouselItemTile_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"CarouselItemTile_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CarouselItemTile_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "showSeller",
          "value": false
        }
      ],
      "kind": "FragmentSpread",
      "name": "BuyerProductTile_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFavoritesItem_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d5c96c80dc8bcf8f8dade3d405359a33";

export default node;
